"use client";

import {
  Button,
  Container,
  Image,
  SimpleGrid,
  Text,
  Title,
} from "@mantine/core";
import Link from "next/link";
import { useTranslations } from "next-intl";
import classes from "./not-found.module.css";
import image from "./not-found.svg";

// Simple 404 page with a button to go home and a button to contact support
// Show a cute SVG with your primary color
export const NotFound = () => {
  const t = useTranslations("components.NotFound");

  return (
    <Container className={classes.root}>
      <SimpleGrid spacing={{ base: 40, sm: 80 }} cols={{ base: 1, sm: 2 }}>
        <Image src={image.src} className={classes.mobileImage} alt="404" />
        <div>
          <Title className={classes.title}>{t("title")}</Title>
          <Text c="dimmed" size="lg">
            {t("description")}
          </Text>
          <Link href={"/dashboard"}>
            <Button
              variant="outline"
              size="md"
              mt="xl"
              className={classes.control}
            >
              {t("backToDashboard")}
            </Button>
          </Link>
        </div>
        <Image src={image.src} className={classes.desktopImage} alt="404" />
      </SimpleGrid>
    </Container>
  );
};
